import { pathOr } from 'ramda';

import { IState } from '../../store';

export const getIsFromSeller = (state: IState) => {
  return pathOr(false, ['offerData', 'offer', 'isFromSeller'], state);
};
